import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/early-years/layoutProps';

const tabs = ['親子班', '幼兒園', '幼稚園'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="kik-kcc-curriculum">
        <h1>京斯敦國際幼稚園／京斯敦幼兒園課程</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>親子班是邁向終身學習及接觸京斯敦雙語課程的第一步，為幼兒早期發展的基礎，親子班可讓孩子：</p>
            <ul className="list">
              <li>適應在家以外的環境</li>
              <li>安心與其他成年人相處，並接受他們的評價</li>
              <li>適應幼稚園的常規和要求</li>
              <li>開始發展不同的社交技巧，與其他小朋友相處愉快</li>
              <li>成為團體的一份子</li>
              <li>熟習使用不同的器材，參與各種不同的活動</li>
            </ul>
            <p>請注意，所有參加親子班的兒童必須要由一位成人陪同完成整節課堂。</p>
            <table>
              <thead>
                <tr>
                  <th className="center">上午班</th>
                  <th className="center">下午班</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="center">
                    星期一、星期三及星期五<br />
                    8:45am 至 11:15am
                  </td>
                  <td className="center">
                    星期一、星期三及星期五<br />
                    1:30pm 至 4:00pm
                  </td>
                </tr>
                <tr>
                  <td className="center">
                    星期二、星期四<br />
                    8:45am 至 11:15am
                  </td>
                  <td className="center">
                    星期二、星期四<br />
                    1:30pm 至 4:00pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              兩歲班由熱心體貼、合資格、母語分別為英語及普通話的班主任教授，有助孩子自然習得雙語能力，並為持續學習奠定基礎。
            </p>
            <p>
              學習環境經細心設計，以遊戲為本，為孩子提供安全的學習空間。學習任務能迎合個別孩子的發展需要，引領孩子持續成長。幼兒園培養孩子成為有自信、活躍的探究者，支持他們順利過渡至幼稚園。
            </p>
            <table>
              <tbody>
                <tr>
                  <td className="center">
                    上午班(每星期五天)<br />
                    8:45am 至 11:45am
                  </td>
                  <td className="center">
                    下午班(每星期五天)<br />
                    1:30pm 至 4:30pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <p>
              京斯敦國際幼稚園為三至四歲的孩子提供溫暖舒適的雙語學習環境。我們明白幼兒具有天生的好奇心，因此設計了完美的空間讓孩子通過中英雙語探索事物。在合資格、母語分別為英語及普通話的幼兒教育工作者的教授下，學生在這裡展開他們的國際文憑小學課程之旅。課程以四個概念為本的國際文憑小學課程雙語探究單元為框架。
            </p>
            <p>
              我們的課程切合孩子的發展，鼓勵孩子發揮探究精神、具批判思維及主動學習。我們的教育方法及學習環境支持沉浸式雙語學習，為孩子的語言發展及雙語溝通能力提供穩固的基礎。
            </p>
            <table>
              <tbody>
                <tr>
                  <td className="center">
                    上午班(每星期五天)<br />
                    8:45am 至 11:45am
                  </td>
                  <td className="center">
                    下午班(每星期五天)<br />
                    1:30pm 至 4:30pm
                  </td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
